// Design tokens — Chatbots. Ref: .md/DESIGN_UIUX.md

export const CHATBOTS_DESIGN = {
  root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pb-[120px]',
  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
  topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
  topbarIdentity: 'min-w-0 flex-1',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0 md:pt-[5px]',
  sectionHeader: 'mt-[18px] first:mt-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',
  stack: 'flex flex-col gap-3.5',
  grid: 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3.5',
  card: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[22px] overflow-hidden min-w-0 flex flex-col cursor-pointer transition-colors hover:border-[#d4d4d8]',
  cardTitle: 'text-[15px] font-semibold text-[#18181b] text-center truncate',
  cardMeta: 'mt-1 text-[13px] text-[#71717a] text-center line-clamp-2',
  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9]',
  ghostButton:
    'inline-flex items-center justify-center gap-1.5 w-full px-3 py-2 rounded-lg border border-[#e7e7ec] bg-white text-[12.5px] font-semibold text-[#52525b] hover:bg-[#f4f4f7]',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonDanger:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#b42318] hover:bg-[#fef3f2] hover:border-[#fecdca]',
  newCard:
    'flex flex-col items-center justify-center p-[22px] rounded-[12px] border border-dashed border-[#d4d4d8] bg-white min-h-[220px] w-full transition-colors hover:border-[#a78bfa] hover:bg-[#ede9fe]/40 cursor-pointer',
  newCardTitle: 'text-[15px] font-semibold text-[#6d28d9]',
  newCardSub: 'mt-1 text-[13px] text-[#71717a] text-center',
  badgeOk: 'w-1.5 h-1.5 rounded-full bg-[#17b26a]',
  badgeNeutral: 'w-1.5 h-1.5 rounded-full bg-[#d4d4d8]',
};

export default CHATBOTS_DESIGN;
